<template>
  <b-modal
    id="content-upload-modal"
    ref="content-upload-modal"
    body-class="p-0"
    centered
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
  >
    <template v-slot:modal-header>
      <div>
        <h2>Add Landing Pages</h2>
        <p
          class="mb-0"
        >
          The landing page URLs you provide will be used to generate content for your campaign and serve as destinations when users click on your display ads. These URLs are analysed to create matching profiles that help SmartMatch connect your ads with contextually relevant content across the publishers you've selected. <br> <br>
        </p>
        <p class="mb-0">
          You can also upload additional content - such as videos, audio files, and PDFs - using the <b> Upload Content Files </b> tab.
        </p>
      </div>
    </template>
    <div>
      <ul class="nav nav-tabs bg-secondary">
        <li
          class="nav-item"
        >
          <button
            :class="['nav-link justify-content-center', { 'active': isUploadUrlsTabSelected }]"
            data-test="upload-urls"
            @click="setSelectedTab('upload-urls')"
            :disabled="isUploadUrlsDisabled()"
          >
            Upload URLs
          </button>
        </li>
        <li
          class="nav-item"
        >
          <button
            :class="['nav-link justify-content-center', { 'active': isUploadContentFilesTabSelected }]"
            data-test="upload-content-files"
            @click="setSelectedTab('upload-content-files')"
            :disabled="isUploadContentFilesTabDisabled()"
          >
            Upload Content Files
          </button>
        </li>
      </ul>
    </div>
    <div>
      <section
        v-show="isUploadUrlsTabSelected"
        class="p-5"
      >
        <upload-urls-tab
          @uploadIsFailed="isUploadButtonLoading = true"
          @closeModal="closeModal"
          ref="upload-urls-tab"
        />
      </section>
      <section
        v-show="isUploadContentFilesTabSelected"
        class="p-5"
      >
        <upload-content-files-tab
          @uploadIsFailed="isUploadButtonLoading = true"
          @closeModal="closeModal"
          ref="upload-content-files-tab"
        />
      </section>
    </div>
    <template v-slot:modal-footer>
      <b-button
        variant="tertiary"
        @click="closeModal()"
      >
        Cancel
      </b-button>
      <b-button
        :class="{ 'btn-loading': isUploadButtonLoading }"
        :disabled="isUploadDisabled()"
        data-test="upload-content-btn"
        variant="primary"
        @click="upload()"
      >
        Upload
      </b-button>
    </template>
  </b-modal>
</template>
<script>

import UploadUrlsTab from '@/modules/content/components/ContentPage/UploadUrlsTab.vue';
import UploadContentFilesTab from '@/modules/content/components/ContentPage/UploadContentFilesTab.vue';

function initialData() {
  return {
    selectedTab: 'upload-urls',
    disabledUpload: false,
    isUploadButtonLoading: false,
  };
}

export default {
  name: 'ContentUploadModal',
  components: { UploadContentFilesTab, UploadUrlsTab },
  data() {
    return initialData();
  },
  computed: {
    isUploadUrlsTabSelected() {
      return this.selectedTab === 'upload-urls';
    },
    isUploadContentFilesTabSelected() {
      return this.selectedTab === 'upload-content-files';
    },
  },
  methods: {
    isUploadUrlsTabActive() {
      return this.$refs['upload-urls-tab'] && this.isUploadUrlsTabSelected;
    },
    isUploadContentFilesTabActive() {
      return this.$refs['upload-content-files-tab'] && this.isUploadContentFilesTabSelected;
    },
    isUploadUrlsDisabled() {
      return this.isUploadContentFilesTabActive() && this.$refs['upload-content-files-tab'].isTabTouched;
    },
    isUploadContentFilesTabDisabled() {
      return this.isUploadUrlsTabActive() && this.$refs['upload-urls-tab'].isTabTouched;
    },
    isUploadDisabled() {
      const activeTab = this.getActiveTab();
      return activeTab ? !activeTab.isUploadValid : true;
    },
    getActiveTab() {
      if (this.isUploadUrlsTabActive()) return this.$refs['upload-urls-tab'];
      if (this.isUploadContentFilesTabActive()) return this.$refs['upload-content-files-tab'];
      return undefined;
    },
    setSelectedTab(tab) {
      this.selectedTab = tab;
    },
    upload() {
      const activeTab = this.getActiveTab();
      if (!this.isUploadButtonLoading && activeTab) {
        this.isUploadButtonLoading = true;
        activeTab.upload();
      }
    },
    resetData() {
      this.$refs['upload-urls-tab'].resetData();
      this.$refs['upload-content-files-tab'].resetData();
      Object.assign(this.$data, initialData());
    },
    closeModal({ fetchArticles = false } = {}) {
      this.resetData();
      this.$root.$emit('bv::hide::modal', 'content-upload-modal');
      if (fetchArticles) this.$emit('fetchArticles');
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .modal-header {
    border-bottom: 0;
  }
}
.nav-tabs {
  height: 72px;
  margin: 0;
  position: relative !important;
}
.nav-item {
  width: 50%;
  height: 42px;
  padding: 0;
  position: absolute !important;
  bottom: 0;
  left: 0;
}
.full-width {
  width: 100% !important;
}
.nav-item:nth-child(2) {
  left: 50%;
}
.nav-link {
  height: 40px;
  width: 100%;
  border-radius: 2px 2px 0 0;
  position: absolute;
  bottom: 0;
  left: 0;

  &.active,
  &:focus {
    height: 48px;
    border-radius: 2px 2px 0 0;
    outline: none;
  }
}
</style>
